// react
import { useContext, useState } from 'react';

// types
import { Account } from '../../../@types';

// context
import { ContextProject } from '../../pages/Project/Project.context';

// hooks
import { useFetch } from '../../../hooks/useFetch';

// fields
import { Select, SelectProps } from '../Select/Select';

// props extended from SelectProps
export type SelectAccountProps = SelectProps;

export const SelectAccount = (props: SelectAccountProps) => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// context
	const { project } = useContext(ContextProject);

	// state
	const [accounts, setAccounts] = useState<Account[]>([]);

	// fetch accounts
	useFetch({
		isEnabled: Boolean(project?.id),
		url: `${process.env.REACT_APP_API_URL}/accounts?project=${project?.id}&fields=id,name,status`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setAccounts(res.data);
			}
		},
	});

	const optionsAccount = accounts.map((account) => {
		return {
			disabled: account.status === 'DEACTIVATED',
			label: account.name,
			MenuItemProps: {
				resource: account,
			},
			value: String(account.id),
		};
	});

	return <Select name="account" {...props} options={optionsAccount} />;
};
